(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec490"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec490"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aAo55", function(module, exports) {

var $9pIpX = parcelRequire("9pIpX");
parcelRequire("cTGu7");

var $juCUL = parcelRequire("juCUL");

var $fFg51 = parcelRequire("fFg51");
const DOMAIN_WHITELIST = (0, $juCUL.loadFromConfig)("DOMAIN_WHITELIST");
try {
    (0, $9pIpX.CrossStorageHub).init(DOMAIN_WHITELIST.map((domain)=>({
            origin: new RegExp(domain),
            allow: [
                "get",
                "set",
                "del",
                "getKeys",
                "clear"
            ]
        })));
} catch (e) {
    console.error("Iframe CrossStorageHub error");
}
(0, $fFg51.moduleHotAccept)(module);

});
parcelRegister("9pIpX", function(module, exports) {


module.exports = {
    CrossStorageClient: (parcelRequire("7OxrW")),
    CrossStorageHub: (parcelRequire("dgZsY"))
};

});
parcelRegister("7OxrW", function(module, exports) {
(function(root) {
    /**
   * Constructs a new cross storage client given the url to a hub. By default,
   * an iframe is created within the document body that points to the url. It
   * also accepts an options object, which may include a timeout, frameId, and
   * promise. The timeout, in milliseconds, is applied to each request and
   * defaults to 5000ms. The options object may also include a frameId,
   * identifying an existing frame on which to install its listeners. If the
   * promise key is supplied the constructor for a Promise, that Promise library
   * will be used instead of the default window.Promise.
   *
   * @example
   * var storage = new CrossStorageClient('https://store.example.com/hub.html');
   *
   * @example
   * var storage = new CrossStorageClient('https://store.example.com/hub.html', {
   *   timeout: 5000,
   *   frameId: 'storageFrame'
   * });
   *
   * @constructor
   *
   * @param {string} url    The url to a cross storage hub
   * @param {object} [opts] An optional object containing additional options,
   *                        including timeout, frameId, and promise
   *
   * @property {string}   _id        A UUID v4 id
   * @property {function} _promise   The Promise object to use
   * @property {string}   _frameId   The id of the iFrame pointing to the hub url
   * @property {string}   _origin    The hub's origin
   * @property {object}   _requests  Mapping of request ids to callbacks
   * @property {bool}     _connected Whether or not it has connected
   * @property {bool}     _closed    Whether or not the client has closed
   * @property {int}      _count     Number of requests sent
   * @property {function} _listener  The listener added to the window
   * @property {Window}   _hub       The hub window
   */ function CrossStorageClient(url, opts) {
        opts = opts || {};
        this._id = CrossStorageClient._generateUUID();
        this._promise = opts.promise || Promise;
        this._frameId = opts.frameId || "CrossStorageClient-" + this._id;
        this._origin = CrossStorageClient._getOrigin(url);
        this._requests = {};
        this._connected = false;
        this._closed = false;
        this._count = 0;
        this._timeout = opts.timeout || 5000;
        this._listener = null;
        this._installListener();
        var frame;
        if (opts.frameId) frame = document.getElementById(opts.frameId);
        // If using a passed iframe, poll the hub for a ready message
        if (frame) this._poll();
        // Create the frame if not found or specified
        frame = frame || this._createFrame(url);
        this._hub = frame.contentWindow;
    }
    /**
   * The styles to be applied to the generated iFrame. Defines a set of properties
   * that hide the element by positioning it outside of the visible area, and
   * by modifying its display.
   *
   * @member {Object}
   */ CrossStorageClient.frameStyle = {
        display: "none",
        position: "absolute",
        top: "-999px",
        left: "-999px"
    };
    /**
   * Returns the origin of an url, with cross browser support. Accommodates
   * the lack of location.origin in IE, as well as the discrepancies in the
   * inclusion of the port when using the default port for a protocol, e.g.
   * 443 over https. Defaults to the origin of window.location if passed a
   * relative path.
   *
   * @param   {string} url The url to a cross storage hub
   * @returns {string} The origin of the url
   */ CrossStorageClient._getOrigin = function(url) {
        var uri, protocol, origin;
        uri = document.createElement("a");
        uri.href = url;
        if (!uri.host) uri = window.location;
        if (!uri.protocol || uri.protocol === ":") protocol = window.location.protocol;
        else protocol = uri.protocol;
        origin = protocol + "//" + uri.host;
        origin = origin.replace(/:80$|:443$/, "");
        return origin;
    };
    /**
   * UUID v4 generation, taken from: http://stackoverflow.com/questions/
   * 105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
   *
   * @returns {string} A UUID v4 string
   */ CrossStorageClient._generateUUID = function() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    };
    /**
   * Returns a promise that is fulfilled when a connection has been established
   * with the cross storage hub. Its use is required to avoid sending any
   * requests prior to initialization being complete.
   *
   * @returns {Promise} A promise that is resolved on connect
   */ CrossStorageClient.prototype.onConnect = function() {
        var client = this;
        if (this._connected) return this._promise.resolve();
        else if (this._closed) return this._promise.reject(new Error("CrossStorageClient has closed"));
        // Queue connect requests for client re-use
        if (!this._requests.connect) this._requests.connect = [];
        return new this._promise(function(resolve, reject) {
            var timeout = setTimeout(function() {
                reject(new Error("CrossStorageClient could not connect"));
            }, client._timeout);
            client._requests.connect.push(function(err) {
                clearTimeout(timeout);
                if (err) return reject(err);
                resolve();
            });
        });
    };
    /**
   * Sets a key to the specified value. Returns a promise that is fulfilled on
   * success, or rejected if any errors setting the key occurred, or the request
   * timed out.
   *
   * @param   {string}  key   The key to set
   * @param   {*}       value The value to assign
   * @returns {Promise} A promise that is settled on hub response or timeout
   */ CrossStorageClient.prototype.set = function(key, value) {
        return this._request("set", {
            key: key,
            value: value
        });
    };
    /**
   * Accepts one or more keys for which to retrieve their values. Returns a
   * promise that is settled on hub response or timeout. On success, it is
   * fulfilled with the value of the key if only passed a single argument.
   * Otherwise it's resolved with an array of values. On failure, it is rejected
   * with the corresponding error message.
   *
   * @param   {...string} key The key to retrieve
   * @returns {Promise}   A promise that is settled on hub response or timeout
   */ CrossStorageClient.prototype.get = function(key) {
        var args = Array.prototype.slice.call(arguments);
        return this._request("get", {
            keys: args
        });
    };
    /**
   * Accepts one or more keys for deletion. Returns a promise that is settled on
   * hub response or timeout.
   *
   * @param   {...string} key The key to delete
   * @returns {Promise}   A promise that is settled on hub response or timeout
   */ CrossStorageClient.prototype.del = function() {
        var args = Array.prototype.slice.call(arguments);
        return this._request("del", {
            keys: args
        });
    };
    /**
   * Returns a promise that, when resolved, indicates that all localStorage
   * data has been cleared.
   *
   * @returns {Promise} A promise that is settled on hub response or timeout
   */ CrossStorageClient.prototype.clear = function() {
        return this._request("clear");
    };
    /**
   * Returns a promise that, when resolved, passes an array of all keys
   * currently in storage.
   *
   * @returns {Promise} A promise that is settled on hub response or timeout
   */ CrossStorageClient.prototype.getKeys = function() {
        return this._request("getKeys");
    };
    /**
   * Deletes the iframe and sets the connected state to false. The client can
   * no longer be used after being invoked.
   */ CrossStorageClient.prototype.close = function() {
        var frame = document.getElementById(this._frameId);
        if (frame) frame.parentNode.removeChild(frame);
        // Support IE8 with detachEvent
        if (window.removeEventListener) window.removeEventListener("message", this._listener, false);
        else window.detachEvent("onmessage", this._listener);
        this._connected = false;
        this._closed = true;
    };
    /**
   * Installs the necessary listener for the window message event. When a message
   * is received, the client's _connected status is changed to true, and the
   * onConnect promise is fulfilled. Given a response message, the callback
   * corresponding to its request is invoked. If response.error holds a truthy
   * value, the promise associated with the original request is rejected with
   * the error. Otherwise the promise is fulfilled and passed response.result.
   *
   * @private
   */ CrossStorageClient.prototype._installListener = function() {
        var client = this;
        this._listener = function(message) {
            var i, origin, error, response;
            // Ignore invalid messages or those after the client has closed
            if (client._closed || !message.data || typeof message.data !== "string") return;
            // postMessage returns the string "null" as the origin for "file://"
            origin = message.origin === "null" ? "file://" : message.origin;
            // Ignore messages not from the correct origin
            if (origin !== client._origin) return;
            // LocalStorage isn't available in the hub
            if (message.data === "cross-storage:unavailable") {
                if (!client._closed) client.close();
                if (!client._requests.connect) return;
                error = new Error("Closing client. Could not access localStorage in hub.");
                for(i = 0; i < client._requests.connect.length; i++)client._requests.connect[i](error);
                return;
            }
            // Handle initial connection
            if (message.data.indexOf("cross-storage:") !== -1 && !client._connected) {
                client._connected = true;
                if (!client._requests.connect) return;
                for(i = 0; i < client._requests.connect.length; i++)client._requests.connect[i](error);
                delete client._requests.connect;
            }
            if (message.data === "cross-storage:ready") return;
            // All other messages
            try {
                response = JSON.parse(message.data);
            } catch (e) {
                return;
            }
            if (!response.id) return;
            if (client._requests[response.id]) client._requests[response.id](response.error, response.result);
        };
        // Support IE8 with attachEvent
        if (window.addEventListener) window.addEventListener("message", this._listener, false);
        else window.attachEvent("onmessage", this._listener);
    };
    /**
   * Invoked when a frame id was passed to the client, rather than allowing
   * the client to create its own iframe. Polls the hub for a ready event to
   * establish a connected state.
   */ CrossStorageClient.prototype._poll = function() {
        var client, interval, targetOrigin;
        client = this;
        // postMessage requires that the target origin be set to "*" for "file://"
        targetOrigin = client._origin === "file://" ? "*" : client._origin;
        interval = setInterval(function() {
            if (client._connected) return clearInterval(interval);
            if (!client._hub) return;
            client._hub.postMessage("cross-storage:poll", targetOrigin);
        }, 1000);
    };
    /**
   * Creates a new iFrame containing the hub. Applies the necessary styles to
   * hide the element from view, prior to adding it to the document body.
   * Returns the created element.
   *
   * @private
   *
   * @param  {string}            url The url to the hub
   * returns {HTMLIFrameElement} The iFrame element itself
   */ CrossStorageClient.prototype._createFrame = function(url) {
        var frame, key;
        frame = window.document.createElement("iframe");
        frame.id = this._frameId;
        // Style the iframe
        for(key in CrossStorageClient.frameStyle)if (CrossStorageClient.frameStyle.hasOwnProperty(key)) frame.style[key] = CrossStorageClient.frameStyle[key];
        window.document.body.appendChild(frame);
        frame.src = url;
        return frame;
    };
    /**
   * Sends a message containing the given method and params to the hub. Stores
   * a callback in the _requests object for later invocation on message, or
   * deletion on timeout. Returns a promise that is settled in either instance.
   *
   * @private
   *
   * @param   {string}  method The method to invoke
   * @param   {*}       params The arguments to pass
   * @returns {Promise} A promise that is settled on hub response or timeout
   */ CrossStorageClient.prototype._request = function(method, params) {
        var req, client;
        if (this._closed) return this._promise.reject(new Error("CrossStorageClient has closed"));
        client = this;
        client._count++;
        req = {
            id: this._id + ":" + client._count,
            method: "cross-storage:" + method,
            params: params
        };
        return new this._promise(function(resolve, reject) {
            var timeout, originalToJSON, targetOrigin;
            // Timeout if a response isn't received after 4s
            timeout = setTimeout(function() {
                if (!client._requests[req.id]) return;
                delete client._requests[req.id];
                reject(new Error("Timeout: could not perform " + req.method));
            }, client._timeout);
            // Add request callback
            client._requests[req.id] = function(err, result) {
                clearTimeout(timeout);
                delete client._requests[req.id];
                if (err) return reject(new Error(err));
                resolve(result);
            };
            // In case we have a broken Array.prototype.toJSON, e.g. because of
            // old versions of prototype
            if (Array.prototype.toJSON) {
                originalToJSON = Array.prototype.toJSON;
                Array.prototype.toJSON = null;
            }
            // postMessage requires that the target origin be set to "*" for "file://"
            targetOrigin = client._origin === "file://" ? "*" : client._origin;
            // Send serialized message
            client._hub.postMessage(JSON.stringify(req), targetOrigin);
            // Restore original toJSON
            if (originalToJSON) Array.prototype.toJSON = originalToJSON;
        });
    };
    /**
   * Export for various environments.
   */ if (0, module.exports) module.exports = CrossStorageClient;
    else module.exports.CrossStorageClient = CrossStorageClient;
})(module.exports);

});

parcelRegister("dgZsY", function(module, exports) {
(function(root) {
    var CrossStorageHub = {};
    /**
   * Accepts an array of objects with two keys: origin and allow. The value
   * of origin is expected to be a RegExp, and allow, an array of strings.
   * The cross storage hub is then initialized to accept requests from any of
   * the matching origins, allowing access to the associated lists of methods.
   * Methods may include any of: get, set, del, getKeys and clear. A 'ready'
   * message is sent to the parent window once complete.
   *
   * @example
   * // Subdomain can get, but only root domain can set and del
   * CrossStorageHub.init([
   *   {origin: /\.example.com$/,        allow: ['get']},
   *   {origin: /:(www\.)?example.com$/, allow: ['get', 'set', 'del']}
   * ]);
   *
   * @param {array} permissions An array of objects with origin and allow
   */ CrossStorageHub.init = function(permissions) {
        var available = true;
        // Return if localStorage is unavailable, or third party
        // access is disabled
        try {
            if (!window.localStorage) available = false;
        } catch (e) {
            available = false;
        }
        if (!available) try {
            return window.parent.postMessage("cross-storage:unavailable", "*");
        } catch (e) {
            return;
        }
        CrossStorageHub._permissions = permissions || [];
        CrossStorageHub._installListener();
        window.parent.postMessage("cross-storage:ready", "*");
    };
    /**
   * Installs the necessary listener for the window message event. Accommodates
   * IE8 and up.
   *
   * @private
   */ CrossStorageHub._installListener = function() {
        var listener = CrossStorageHub._listener;
        if (window.addEventListener) window.addEventListener("message", listener, false);
        else window.attachEvent("onmessage", listener);
    };
    /**
   * The message handler for all requests posted to the window. It ignores any
   * messages having an origin that does not match the originally supplied
   * pattern. Given a JSON object with one of get, set, del or getKeys as the
   * method, the function performs the requested action and returns its result.
   *
   * @param {MessageEvent} message A message to be processed
   */ CrossStorageHub._listener = function(message) {
        var origin, targetOrigin, request, method, error, result, response;
        // postMessage returns the string "null" as the origin for "file://"
        origin = message.origin === "null" ? "file://" : message.origin;
        // Handle polling for a ready message
        if (message.data === "cross-storage:poll") return window.parent.postMessage("cross-storage:ready", message.origin);
        // Ignore the ready message when viewing the hub directly
        if (message.data === "cross-storage:ready") return;
        // Check whether message.data is a valid json
        try {
            request = JSON.parse(message.data);
        } catch (err) {
            return;
        }
        // Check whether request.method is a string
        if (!request || typeof request.method !== "string") return;
        method = request.method.split("cross-storage:")[1];
        if (!method) return;
        else if (!CrossStorageHub._permitted(origin, method)) error = "Invalid permissions for " + method;
        else try {
            result = CrossStorageHub["_" + method](request.params);
        } catch (err) {
            error = err.message;
        }
        response = JSON.stringify({
            id: request.id,
            error: error,
            result: result
        });
        // postMessage requires that the target origin be set to "*" for "file://"
        targetOrigin = origin === "file://" ? "*" : origin;
        window.parent.postMessage(response, targetOrigin);
    };
    /**
   * Returns a boolean indicating whether or not the requested method is
   * permitted for the given origin. The argument passed to method is expected
   * to be one of 'get', 'set', 'del' or 'getKeys'.
   *
   * @param   {string} origin The origin for which to determine permissions
   * @param   {string} method Requested action
   * @returns {bool}   Whether or not the request is permitted
   */ CrossStorageHub._permitted = function(origin, method) {
        var available, i, entry, match;
        available = [
            "get",
            "set",
            "del",
            "clear",
            "getKeys"
        ];
        if (!CrossStorageHub._inArray(method, available)) return false;
        for(i = 0; i < CrossStorageHub._permissions.length; i++){
            entry = CrossStorageHub._permissions[i];
            if (!(entry.origin instanceof RegExp) || !(entry.allow instanceof Array)) continue;
            match = entry.origin.test(origin);
            if (match && CrossStorageHub._inArray(method, entry.allow)) return true;
        }
        return false;
    };
    /**
   * Sets a key to the specified value.
   *
   * @param {object} params An object with key and value
   */ CrossStorageHub._set = function(params) {
        window.localStorage.setItem(params.key, params.value);
    };
    /**
   * Accepts an object with an array of keys for which to retrieve their values.
   * Returns a single value if only one key was supplied, otherwise it returns
   * an array. Any keys not set result in a null element in the resulting array.
   *
   * @param   {object} params An object with an array of keys
   * @returns {*|*[]}  Either a single value, or an array
   */ CrossStorageHub._get = function(params) {
        var storage, result, i, value;
        storage = window.localStorage;
        result = [];
        for(i = 0; i < params.keys.length; i++){
            try {
                value = storage.getItem(params.keys[i]);
            } catch (e) {
                value = null;
            }
            result.push(value);
        }
        return result.length > 1 ? result : result[0];
    };
    /**
   * Deletes all keys specified in the array found at params.keys.
   *
   * @param {object} params An object with an array of keys
   */ CrossStorageHub._del = function(params) {
        for(var i = 0; i < params.keys.length; i++)window.localStorage.removeItem(params.keys[i]);
    };
    /**
   * Clears localStorage.
   */ CrossStorageHub._clear = function() {
        window.localStorage.clear();
    };
    /**
   * Returns an array of all keys stored in localStorage.
   *
   * @returns {string[]} The array of keys
   */ CrossStorageHub._getKeys = function(params) {
        var i, length, keys;
        keys = [];
        length = window.localStorage.length;
        for(i = 0; i < length; i++)keys.push(window.localStorage.key(i));
        return keys;
    };
    /**
   * Returns whether or not a value is present in the array. Consists of an
   * alternative to extending the array prototype for indexOf, since it's
   * unavailable for IE8.
   *
   * @param   {*}    value The value to find
   * @parma   {[]*}  array The array in which to search
   * @returns {bool} Whether or not the value was found
   */ CrossStorageHub._inArray = function(value, array) {
        for(var i = 0; i < array.length; i++){
            if (value === array[i]) return true;
        }
        return false;
    };
    /**
   * A cross-browser version of Date.now compatible with IE8 that avoids
   * modifying the Date object.
   *
   * @return {int} The current timestamp in milliseconds
   */ CrossStorageHub._now = function() {
        if (typeof Date.now === "function") return Date.now();
        return new Date().getTime();
    };
    /**
   * Export for various environments.
   */ if (0, module.exports) module.exports = CrossStorageHub;
    else module.exports.CrossStorageHub = CrossStorageHub;
})(module.exports);

});


parcelRegister("cTGu7", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $963b93adecb41b12$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = $963b93adecb41b12$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $963b93adecb41b12$var$runtime;
    else Function("r", "regeneratorRuntime = r")($963b93adecb41b12$var$runtime);
}

});

parcelRegister("juCUL", function(module, exports) {

$parcel$export(module.exports, "loadFromConfig", function () { return $e30f0149b4dc5417$export$828b41d840fb3550; });

var $917yd = parcelRequire("917yd");

var $KEa4n = parcelRequire("KEa4n");

var $26IKT = parcelRequire("26IKT");

var $cF4UY = parcelRequire("cF4UY");
function $e30f0149b4dc5417$var$_extends() {
    $e30f0149b4dc5417$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e30f0149b4dc5417$var$_extends.apply(this, arguments);
}
var $e30f0149b4dc5417$var$loadConfig = function loadConfig() {
    var parsedConfig = $e30f0149b4dc5417$var$_extends($e30f0149b4dc5417$var$_extends($e30f0149b4dc5417$var$_extends({}, (0, (/*@__PURE__*/$parcel$interopDefault($KEa4n)))), (0, (/*@__PURE__*/$parcel$interopDefault($26IKT)))), {
        RELATIVE_PATH: (0, $cF4UY.getRelativePath)()
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($917yd))).window) (0, (/*@__PURE__*/$parcel$interopDefault($917yd))).window.UNIFICATION_ENVIRONMENT_CONFIG = parsedConfig;
    return parsedConfig;
};
$e30f0149b4dc5417$var$loadConfig();
var $e30f0149b4dc5417$export$828b41d840fb3550 = function loadFromConfig(key) {
    var _a;
    var configObject = ((_a = (0, (/*@__PURE__*/$parcel$interopDefault($917yd))).window) === null || _a === void 0 ? void 0 : _a.UNIFICATION_ENVIRONMENT_CONFIG) || $e30f0149b4dc5417$var$_extends($e30f0149b4dc5417$var$_extends($e30f0149b4dc5417$var$_extends({}, (0, (/*@__PURE__*/$parcel$interopDefault($KEa4n)))), (0, (/*@__PURE__*/$parcel$interopDefault($26IKT)))), {
        RELATIVE_PATH: ""
    });
    return configObject[key];
};

});
parcelRegister("917yd", function(module, exports) {
"use strict";
module.exports = typeof self === "object" && self.self === self && self || typeof $parcel$global === "object" && $parcel$global.global === $parcel$global && $parcel$global || module.exports;

});

parcelRegister("KEa4n", function(module, exports) {
module.exports = JSON.parse('{"ACCESS_POLICIES":{"APES_API":"https://api.prod.cd.beachbodyondemand.com/user-apes/apes","APES_API_KEY":"ny3fXZ8nPVa39ar5wg0ht6G2xrqvqCIK3MtpoLwJ"},"ALGOLIA":{"APP_ID":"JW2BCPBIT3","API_KEY":"2501f76b2121232f72a3ecda634efe39","INDEXES":{"LESSONS":"LESSONS_APPSYNC","PRODUCTS":"unification_product_catalog","PROGRAMS":"PROGRAMS_APPSYNC","PROGRAM_MATERIALS":"PROGRAM_MATERIALS_APPSYNC","RECIPES":"RECIPES_APPSYNC","WORKOUTS":"WORKOUTS_V2","OTHER":"OTHER_VIDEOS_APPSYNC","SUGGESTIONS":"AUTO_SUGGESTIONS"},"FACETS":{"RECIPES":{"CONTAINER":"videoDetailsModalRecipeSection.containerRowOne.facet","DISH":"Dish.title","MAIN_INGREDIENT":"MainIngredient.title","MEAL":"Meal.facet","PROGRAM":"program.facet","WORKS_WELL_FOR":"videoDetailsModalContentGroupOne.items.facet"},"WORKOUTS":{"BODY_PART":"bodyParts","DURATION":"videoDurationMinutes","EQUIPMENT":"requiredEquips","LEVEL":"workoutLevels","PROGRAM":"program.title","TIER":"tier","TRAINER":"trainer.name","TYPE":"workoutTypes.items"},"LESSONS":{"PROGRAM":"program.title"},"PROGRAMS":{"DURATION":"programDuration.range","TRAINER":"trainer.name","TYPE":"workoutType.title"},"PROGRAMS_MATERIALS":{"PROGRAM":"program.title"},"PRODUCT":{"CATEGORY":"filters.ByParentCategory","CUSTOMER_TYPE":"customerTypesForView","CUSTOMER_ROLES":"customerRoles","GEAR":"filters.ByTypeofGear","GENDER":"filters.ByGender","FLAVOR":"filters.ByFlavor","LEVEL":"filters.ByProgramLevel","PROGRAM":"filters.ByProgram","PROGRAM_TYPE":"filters.ByProgramTypes","SIZE":"filters.BySize","STYLE":"filters.ByStyle","SUBCATEGORY_SHAKEOLOGY":"subParentCategory.Shakeology","TITLE":"title","TRAINER":"filters.ByTrainer","TYPE":"filters.ByOfType"}}},"ALL_ACCESS":"https://fs6.formsite.com/beachbody/form161/index.html","APPSYNC":{"API_URL":"https://kgeaco34efax5g6zyofnvgtife.appsync-api.us-west-2.amazonaws.com/graphql","API_KEY":"da2-4g2il7newvhcndanv4wic4a73e","CACHE_EXPIRE_MINUTES":15,"IS_PREVIEW":false},"APP_DOMAIN_LIST":{"TBB":"https://www.teambeachbody.com","BB":"https://bodi.com/bodcheckout?referralProgramId=BODi","BLOG":"https://www.beachbodyondemand.com/blog","COO":"https://coach.teambeachbody.com","SHAC":"https://shareacart.teambeachbody.com","CO":"https://coach.teambeachbody.com","BOD":"https://www.beachbodyondemand.com","BODI":"https://www.teambeachbody.com","CMS":"bod-cms-assets"},"BOD_CHECKOUT_URL":"/shop/{{countryCode}}/d/bodcheckout","BODI":{"NUTRITION_PLUS_URL":"/d/bodcheckout","ENTITLEMENT":"BODINT"},"BODI_VIDEOS_DEEP_LINKING_ENABLED_FLAG":false,"STATIC_API":{"URL":"https://devices-static.beachbodyondemand.com/v2"},"CART_API":{"URL":"https://www.teambeachbody.com/rest/model/atg/commerce/ShoppingCartActor/bodsummary"},"COCOA_API":{"URL":"https://cocoa-prod.prod.cd.beachbodyondemand.com/v1.0","KEY":"Y7Xa9iTYjY4hRlOp10QFG53A4TH16BG885GpbZ3i"},"CONTENFUL_DOMAINS":{"BeachbodyOnDemand.com":"BOD","TeamBeachbody.com":"TBB","BODBlog":"BLOG","CoachOffice":"COO","ShareACart":"SHAC"},"DOMAIN_WHITELIST":[".beachbody.com",".beachbodyondemand.com",".coo.tbbtest.com",".teambeachbody.com","preview.teambeachbody.local"],"ENTITLEMENTS_API":{"API_KEY":"rKmdhM06td4O7tDvEplY7NVjmYiFqVBa9atawhui","URL":"https://ebs.prod.gateway.beachbody.com/userEntitlements"},"IFRAME_URL":"https://unification.prod.cd.beachbodyondemand.com/latest/iframe/index.html","PROFILE":{"URL":"https://api.prod.cd.beachbodyondemand.com","API_KEY":"ny3fXZ8nPVa39ar5wg0ht6G2xrqvqCIK3MtpoLwJ"},"GEOLOCATION":{"URL":"https://www.beachbodyondemand.com/api/geo"},"VIDEO_PLAYER":{"VHS_API":"https://api.prod.cd.beachbodyondemand.com/vhs/v2","API":"https://api.prod.cd.beachbodyondemand.com/video-api/v2","VHS_API_KEY":"Y7Xa9iTYjY4hRlOp10QFG53A4TH16BG885GpbZ3i","LEGAL_API":"https://devices-static.beachbodyondemand.com/v2/legal","CHROMECAST_APP_ID":"D998E862","API_KEY":"Y7Xa9iTYjY4hRlOp10QFG53A4TH16BG885GpbZ3i","CONVIVA_CUSTOMER_KEY":"3e6281cdf7991c82a612a2d3891ca86ada88e22c","USE_COCOA_API":true,"RETRY_ATTEMPTS":2,"RATINGS_API_KEY":"CCOGMiX1XH2iaERs5LavL6UMo47OaYUu3f8n4o9P","RATINGS_API":"https://api.prod.cd.beachbodyondemand.com/ratings-api/ratings"},"VIDEO_PLAYER_WAIVER":{"API_KEY":"Y7Xa9iTYjY4hRlOp10QFG53A4TH16BG885GpbZ3i","URL":"https://api.prod.cd.beachbodyondemand.com/waivers-api/waivers"},"TBB_MY_ACCOUNT_PATH":"/shop/{countryCode}/account/settings","TBB_SHOP_LIST":{"en_ca":"7000002","fr_ca":"7000002","fr_fr":"TBB-FR","en_gb":"TBB-GB","en_us":"1400002","es_us":"1400002"},"ELEMENT_ID_MAP":{"CO":{"footer":"global-footer","topNav":"global-topNav"},"BOD":{"footer":"unification-footer","topNav":"unification-topNav"},"TBB":{"footer":"globalFooter","topNav":"globalNav"},"COO":{"topNav":"global-topNav","footer":"global-footer"},"SHAC":{"topNav":"globalNav","footer":"globalFooter"}},"BODI_PROMO_MODAL_ENABLED_FLAG":true,"IS_TEST_IDS_ENABLED_FLAG":false,"IS_ALGOLIA_BACKEND_SEARCH_ENABLED_FLAG":true,"PERSISTENT_URL_PARAMS":["tracking","source","icid","trainername","programid","programname","referralprogramid","referringrepid","locale"],"HIDDEN_SHOPPING_CATEGORIES":[],"BODI_MULTIPLE_TRAINER_TBB_PARAMS":{"Idalis & Megan":"IdalisVelasquez-MeganDavies","Amoila & Lacee":"AmoilaCesar-LaceeGreen","Amoila & Joel":"AmoilaCesar-JoelFreeman","Jericho & Elise":"JerichoMcMatthews-EliseJoan","Elise & Ilana":"EliseJoan-IlanaMuhlstein","Autumn & Shaun T":"AutumnCalabrese-ShaunT"},"DIRECT_RESPONSE_MARKETING_REGIONS":["XX"],"SEARCH_BAR_DEBOUNCE_INTERVAL_MS":400,"VERSION_NAME_URL":"https://unification.prod.cd.beachbodyondemand.com/latest/version.txt","PDF_RECIPE_TEMPLATE_ENABLED_FLAG":false,"RELATIVE_PATH":"https://unification.prod.cd.beachbodyondemand.com/latest/script","SEARCH_API":{"KEY":"Y7Xa9iTYjY4hRlOp10QFG53A4TH16BG885GpbZ3i","URL":"https://api.prod.cd.beachbodyondemand.com/search-index"}}');

});

parcelRegister("26IKT", function(module, exports) {
module.exports = JSON.parse('{"IFRAME_URL":"https://unification.prod.cd.beachbodyondemand.com/latest/iframe/index.html","APPSYNC":{"API_URL":"https://kgeaco34efax5g6zyofnvgtife.appsync-api.us-west-2.amazonaws.com/graphql","API_KEY":"da2-4g2il7newvhcndanv4wic4a73e","CACHE_EXPIRE_MINUTES":15,"IS_PREVIEW":false},"DOMAIN_WHITELIST":[".beachbody.com",".beachbodyondemand.com",".coo.tbbtest.com",".teambeachbody.com","preview.teambeachbody.local"],"APP_DOMAIN_LIST":{"TBB":"https://www.teambeachbody.com","BB":"https://bodi.com/bodcheckout?referralProgramId=BODi","BODI":"https://www.bodi.com","BLOG":"https://www.beachbodyondemand.com/blog","CO":"https://coach.teambeachbody.com","BOD":"https://www.beachbodyondemand.com","SHAC":"https://shareacart.teambeachbody.com","COO":"https://coach.teambeachbody.com","CMS":"bod-cms-assets"},"VIDEO_PLAYER":{"VHS_API":"https://api.prod.cd.beachbodyondemand.com/vhs/v2","API":"https://api.prod.cd.beachbodyondemand.com/video-api/v2","VHS_API_KEY":"Y7Xa9iTYjY4hRlOp10QFG53A4TH16BG885GpbZ3i","USE_COCOA_API":true,"API_KEY":"Y7Xa9iTYjY4hRlOp10QFG53A4TH16BG885GpbZ3i","CHROMECAST_APP_ID":"D998E862","CONVIVA_CUSTOMER_KEY":"3e6281cdf7991c82a612a2d3891ca86ada88e22c","LEGAL_API":"https://devices-static.beachbodyondemand.com/v2/legal","RATINGS_API":"https://api.prod.cd.beachbodyondemand.com/ratings-api/ratings","RETRY_ATTEMPTS":2,"RATINGS_API_KEY":"CCOGMiX1XH2iaERs5LavL6UMo47OaYUu3f8n4o9P"},"PROFILE":{"URL":"https://api.prod.cd.beachbodyondemand.com","API_KEY":"ny3fXZ8nPVa39ar5wg0ht6G2xrqvqCIK3MtpoLwJ"},"ALGOLIA":{"API_KEY":"2501f76b2121232f72a3ecda634efe39","INDEXES":{"OTHER":"OTHER_VIDEOS_V2","PRODUCTS":"COMMERCE_PRODUCTS","RECIPES":"RECIPES_V2","SUGGESTIONS":"AUTO_SUGGESTIONS_V2","PROGRAMS":"PROGRAMS_V2","LESSONS":"LESSONS_V2","WORKOUTS":"WORKOUTS_V2","PROGRAM_MATERIALS":"PROGRAM_MATERIALS_V2"},"FACETS":{"WORKOUTS":{"LEVEL":"fitnessLevels.facet","EQUIPMENT":"requiredEquipsDevices","TYPE":"workoutTypes.items","BODY_PART":"bodyParts","TIER":"tier","TRAINER":"trainer.name","PROGRAM":"program.title","DURATION":"videoDurationMinutes"},"RECIPES":{"CONTAINER":"containerQuantities.container.facet","WORKS_WELL_FOR":"dietaryGroups.facet","DISH":"dishes.title","MAIN_INGREDIENT":"ingredientsMain.title","MEAL":"meals.facet","PROGRAM":"program.title"},"PRODUCT":{"STYLE":"filters.ByStyle","GENDER":"filters.ByGender","CATEGORY":"filters.ByParentCategory","CUSTOMER_ROLES":"customerRoles","TYPE":"filters.ByOfType","LEVEL":"filters.ByProgramLevel","FLAVOR":"filters.ByFlavor","TRAINER":"filters.ByTrainer","CUSTOMER_TYPE":"customerTypesForView","SUBCATEGORY_SHAKEOLOGY":"subParentCategory.Shakeology","GEAR":"filters.ByTypeofGear","TITLE":"title","PROGRAM_TYPE":"filters.ByProgramTypes","SIZE":"filters.BySize","PROGRAM":"filters.ByProgram"},"LESSONS":{"PROGRAM":"program.title"},"PROGRAMS":{"TRAINER":"trainer.name","DURATION":"programDuration.range","TYPE":"workoutType.title"},"PROGRAMS_MATERIALS":{"PROGRAM":"program.title"}},"APP_ID":"JW2BCPBIT3"},"GROUPS_API":{"API_KEY":"Y7Xa9iTYjY4hRlOp10QFG53A4TH16BG885GpbZ3i","URL":"https://api.prod.cd.beachbodyondemand.com/groups-api/v2/profile/groups/"},"ENTITLEMENTS_API":{"API_KEY":"rKmdhM06td4O7tDvEplY7NVjmYiFqVBa9atawhui","URL":"https://ebs.prod.gateway.beachbody.com/userEntitlements"},"BODI_PROMO_MODAL_ENABLED_FLAG":true,"SEARCH_API":{"KEY":"Y7Xa9iTYjY4hRlOp10QFG53A4TH16BG885GpbZ3i","URL":"https://api.prod.cd.beachbodyondemand.com/search-index"},"BODI":{"ENTITLEMENT":"BODINT","NUTRITION_PLUS_URL":"/d/bodcheckout"},"PERSISTENT_URL_PARAMS":["tracking","source","icid","trainername","programid","programname","referralprogramid","referringrepid","locale"],"ACCESS_POLICIES":{"APES_API":"https://api.prod.cd.beachbodyondemand.com/user-apes/apes","APES_API_KEY":"ny3fXZ8nPVa39ar5wg0ht6G2xrqvqCIK3MtpoLwJ"},"ELEMENT_ID_MAP":{"COO":{"topNav":"global-topNav","footer":"global-footer"},"SHAC":{"topNav":"globalNav","footer":"globalFooter"},"CO":{"footer":"global-footer","topNav":"global-topNav"},"BOD":{"footer":"unification-footer","topNav":"unification-topNav"},"TBB":{"footer":"globalFooter","topNav":"globalNav"}},"SEARCH_BAR_DEBOUNCE_INTERVAL_MS":400,"VIDEO_PLAYER_WAIVER":{"URL":"https://api.prod.cd.beachbodyondemand.com/waivers-api/waivers","API_KEY":"Y7Xa9iTYjY4hRlOp10QFG53A4TH16BG885GpbZ3i"},"IS_TEST_IDS_ENABLED_FLAG":false,"PDF_RECIPE_TEMPLATE_ENABLED_FLAG":false,"COCOA_API":{"URL":"https://cocoa-prod.prod.cd.beachbodyondemand.com/v1.0","KEY":"Y7Xa9iTYjY4hRlOp10QFG53A4TH16BG885GpbZ3i"},"GEOLOCATION":{"URL":"https://www.beachbodyondemand.com/api/geo"},"IS_ALGOLIA_BACKEND_SEARCH_ENABLED_FLAG":true,"VERSION_NAME_URL":"https://unification.prod.cd.beachbodyondemand.com/latest/version.txt","DIRECT_RESPONSE_MARKETING_REGIONS":["XX"],"STATIC_API":{"URL":"https://devices-static.beachbodyondemand.com/v2"}}');

});

parcelRegister("cF4UY", function(module, exports) {

$parcel$export(module.exports, "getRelativePath", function () { return $937d20f8653ffd61$export$ae9fda833d91ed65; });

var $917yd = parcelRequire("917yd");

var $vXPj4 = parcelRequire("vXPj4");
var $937d20f8653ffd61$export$3b97b5b114d205f7;
(function(DeviceTypes) {
    DeviceTypes["mobile"] = "mobile";
    DeviceTypes["desktop"] = "desktop";
    DeviceTypes["tablet"] = "tablet";
})($937d20f8653ffd61$export$3b97b5b114d205f7 || ($937d20f8653ffd61$export$3b97b5b114d205f7 = {}));
var $937d20f8653ffd61$export$dc393d7e62097e59 = function matchMedia(breakpoint) {
    var _a;
    var matchMedia = (_a = (0, (/*@__PURE__*/$parcel$interopDefault($917yd))).window) === null || _a === void 0 ? void 0 : _a.matchMedia;
    if (matchMedia) {
        var _matchMedia = matchMedia("screen and (min-width: ".concat(breakpoint, "px)")), matches = _matchMedia.matches;
        return matches;
    }
    return true;
};
var $937d20f8653ffd61$export$abfb0136cf8e916b = function getDeviceType() {
    var isDesktop = $937d20f8653ffd61$export$dc393d7e62097e59((0, $vXPj4.Breakpoints).xlarge);
    var isTablet = $937d20f8653ffd61$export$dc393d7e62097e59((0, $vXPj4.Breakpoints).large);
    var deviceType = isDesktop && $937d20f8653ffd61$export$3b97b5b114d205f7.desktop || isTablet && $937d20f8653ffd61$export$3b97b5b114d205f7.tablet || $937d20f8653ffd61$export$3b97b5b114d205f7.mobile;
    return deviceType;
};
var $937d20f8653ffd61$export$ae9fda833d91ed65 = function getRelativePath() {
    var _a, _b, _c;
    return ((_c = (_b = (_a = (0, (/*@__PURE__*/$parcel$interopDefault($917yd))).document) === null || _a === void 0 ? void 0 : _a.currentScript) === null || _b === void 0 ? void 0 : _b.getAttribute("src")) === null || _c === void 0 ? void 0 : _c.split("/").slice(0, -1).join("/")) || "";
};
var $937d20f8653ffd61$export$e6ff2011d62ce5d7 = function resolveRelativeUrl(originalUrl, _relativePath) {
    var relativePath = _relativePath || $937d20f8653ffd61$export$ae9fda833d91ed65();
    if (!originalUrl || !relativePath) return originalUrl;
    try {
        var originalUrlParsed = new URL(originalUrl);
        var relativeUrlParsed = new URL(relativePath);
        return "".concat(relativeUrlParsed.origin).concat(originalUrlParsed.pathname).concat(originalUrlParsed.search).concat(originalUrlParsed.hash);
    } catch (e) {
        console.warn(e, {
            originalUrl: originalUrl,
            relativePath: relativePath
        });
        return originalUrl;
    }
};

});
parcelRegister("vXPj4", function(module, exports) {

$parcel$export(module.exports, "Breakpoints", function () { return $06014daac127be53$export$c38d2c1bff643203; });
var $06014daac127be53$export$c38d2c1bff643203;
(function(Breakpoints) {
    Breakpoints[Breakpoints["small"] = 0] = "small";
    Breakpoints[Breakpoints["medium"] = 640] = "medium";
    Breakpoints[Breakpoints["large"] = 768] = "large";
    Breakpoints[Breakpoints["xlarge"] = 1060] = "xlarge";
    Breakpoints[Breakpoints["xxlarge"] = 1200] = "xxlarge";
})($06014daac127be53$export$c38d2c1bff643203 || ($06014daac127be53$export$c38d2c1bff643203 = {}));

});



parcelRegister("fFg51", function(module, exports) {

$parcel$export(module.exports, "moduleHotAccept", function () { return $b677288516990615$export$e38ce6b6f9caf270; });
var $b677288516990615$export$e38ce6b6f9caf270 = function moduleHotAccept(_ref) {
    var hot = _ref.hot;
    hot === null || hot === void 0 || hot.accept();
};

});



parcelRequire("aAo55");
})();
//# sourceMappingURL=iframe.js.map
